import '../../App.css';
import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, InputGroup } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';

function ModalEditarPlano({currentPage}) {
    const { EditarPlanoNegocio, EdicaoPlanoNegocio, setEdicaoPlanoNegocio, setModalEditarPlanoNegocio, TipoPlanoNegocio, PlanoNegocios, Avaliacao, Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [tipo, setTipo] = useState('')

    const handleChange = (event) => {
        const { name, value } = event.target;

        setEdicaoPlanoNegocio((prev) => ({
            ...prev,
            ...(name === "avaliacaoKey"
                ? {
                    avaliacaoPlanoNegocio: {
                        ...prev.avaliacaoPlanoNegocio,
                        key: value !== "0" ? value : undefined
                    }
                }
                : { [name]: value })
        }));
    };


    const handleChangeRadio = (event) => {
        const { name } = event.target;

        setEdicaoPlanoNegocio({
            ...EdicaoPlanoNegocio,
            custo: name === "custo",
            data: name === "data",
            pessoa: name === "pessoa",
        });
    };

    const handleTipo = (event) => {
        const novoTipo = event.target.value;
        atualizarTipoInput(novoTipo);

        setEdicaoPlanoNegocio((prevState) => ({
            ...prevState,
            [event.target.name]: novoTipo,
            valor: ""
        }));
    };

    const atualizarTipoInput = (novoTipo) => {
        switch (novoTipo) {
            case "NUMERO":
                setTipo("number");
                break;
            case "DATA":
                setTipo("date");
                break;
            case "MOEDA":
                setTipo("number");
                break;
            case "LISTA":
                setTipo("lista");
                break;
            case "TEXTO":
                setTipo("text");
                break;
            default:
                setTipo("");
        }
    };

    useEffect(() => {
        if (EdicaoPlanoNegocio?.tipo) {
            atualizarTipoInput(EdicaoPlanoNegocio.tipo);
        }
    }, [EdicaoPlanoNegocio]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar plano de negócio</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarPlanoNegocio(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            {/* <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Avaliação</Form.Label>
                                    <Form.Control maxLength={100} defaultValue={EdicaoPlanoNegocio.avaliacaoPlanoNegocio.descricao} onChange={handleChange} name="avaliacao" />
                                </Form.Group>
                            </Col> */}
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Indicador</Form.Label>
                                    <Form.Control maxLength={100} defaultValue={EdicaoPlanoNegocio.indicador} onChange={handleChange} name="indicador" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleTipo} name="tipo">
                                        <option value="0">Selecione</option>
                                        {TipoPlanoNegocio?.map((item, index) => {
                                            return (
                                                <option key={index} value={item} selected={item == EdicaoPlanoNegocio?.tipo ? true : false}>{item}</option>
                                            )

                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                {(tipo === "lista" || EdicaoPlanoNegocio?.tipo === "LISTA") ?
                                    <Form.Group className="mb-3">
                                        <Form.Label>Valor</Form.Label>
                                        <Form.Select aria-label="Default select example" defaultValue={EdicaoPlanoNegocio.valor} onChange={handleChange} name="valor">
                                            <option value="Selecione">Selecione</option>
                                            <option value="Muito baixo">Muito baixo</option>
                                            <option value="Baixo">Baixo</option>
                                            <option value="Médio">Médio</option>
                                            <option value="Alto">Alto</option>
                                            <option value="Muito alto">Muito alto</option>
                                        </Form.Select>
                                    </Form.Group>
                                    :
                                    (EdicaoPlanoNegocio?.tipo === "MOEDA") ?
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text id="basic-addon1">R$</InputGroup.Text>
                                                <Form.Control
                                                    type="text"
                                                    maxLength={100}
                                                    value={EdicaoPlanoNegocio.valor}
                                                    onChange={handleChange}
                                                    name="valor"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                        :
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control type={tipo} maxLength={100} defaultValue={EdicaoPlanoNegocio.valor} onChange={handleChange} name="valor" />
                                        </Form.Group>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Avaliação relacionada</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleChange} value={EdicaoPlanoNegocio?.avaliacaoPlanoNegocio?.key || "0"} name="avaliacaoKey">
                                        <option value="0">Selecione</option>
                                        {Avaliacao?.map((item, index) => {
                                            return (
                                                <option key={index}
                                                    value={item.key}
                                                    selected={item.key == (EdicaoPlanoNegocio?.avaliacaoPlanoNegocio ? EdicaoPlanoNegocio?.avaliacaoPlanoNegocio?.key : "") ? true : false}
                                                >
                                                    {item.descricao}</option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {['radio'].map((type) => (
                                <div className="mb-3">
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="radio1"
                                        label="Custo"
                                        name="custo"
                                        onChange={handleChangeRadio}
                                        checked={EdicaoPlanoNegocio?.custo}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="radio2"
                                        label="Data"
                                        name="data"
                                        onChange={handleChangeRadio}
                                        checked={EdicaoPlanoNegocio?.data}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="radio3"
                                        label="Pessoa"
                                        name="pessoa"
                                        onChange={handleChangeRadio}
                                        checked={EdicaoPlanoNegocio?.pessoa}
                                    />
                                </div>
                            ))}
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarPlanoNegocio(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={() => EditarPlanoNegocio(currentPage)}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarPlano